module.exports = __webpack_public_path__ + "static/media/matterhorn.85b783ee.mp4";


//////////////////
// WEBPACK FOOTER
// ./catalog/stage/matterhorn.mp4
// module id = 782
// module chunks = 103